import React, { useState, useEffect } from 'react';
import { inject, observer } from "mobx-react";
import { Dialog, FormGroup } from "@blueprintjs/core";
import Flexbox from 'flexbox-react';
import { FilledButton } from '../buttons-20250224T111359Z-001/buttons';
import ToastStore from "../../stores/ToastStore";

const RatingLabelDialog = inject("ToastStore")(
    observer(({
    isOpen,
    onClose,
    onSave,
    startRange,
    endRange,
    existingLabels = []
}) => {


    const initializeRatings = () => {
        const total = endRange - startRange + 1;

        const defaultRatings = Array.from({ length: total }, (_, i) => ({
            value: startRange + i,
            label: ""
        }));

        // Merge existing labels
        existingLabels.forEach(el => {
            const index = defaultRatings.findIndex(r => r.value === Number(el.value));
            if (index > -1) defaultRatings[index].label = el.label;
        });

        return defaultRatings;
    };

    const [ratingLabels, setRatingLabels] = useState(initializeRatings());

    useEffect(() => {
        if (!isOpen) return;  // 👈 prevent premature reset
    
        const total = endRange - startRange + 1;
    
        let newList = Array.from({ length: total }, (_, i) => ({
            value: startRange + i,
            label: ""
        }));
    
        existingLabels.forEach(el => {
            const index = newList.findIndex(r => r.value === Number(el.value));
            if (index > -1) {
                newList[index].label = el.label;
            }
        });
    
        setRatingLabels(newList);
    }, [startRange, endRange, existingLabels, isOpen]);
    

    // useEffect(() => {
    //     const total = endRange - startRange + 1;
    
    //     let newList = Array.from({ length: total }, (_, i) => ({
    //         value: startRange + i,
    //         label: ""
    //     }));
    
    //     const labelSource =
    //         existingLabels.length > 0 ? existingLabels : ratingLabels;
    
    //     labelSource.forEach(el => {
    //         const index = newList.findIndex(
    //             r => r.value === Number(el.value)
    //         );
    //         if (index > -1) newList[index].label = el.label;
    //     });
    
    //     setRatingLabels(newList);
    // }, [startRange, endRange, existingLabels]);
    

    const updateLabel = (value, newLabel) => {
        setRatingLabels(prev =>
            prev.map(item =>
                item.value === value ? { ...item, label: newLabel } : item
            )
        );
    };

    const handleSave = () => {
        const anyFilled = ratingLabels.some(r => r.label.trim() !== "");
        const allFilled = ratingLabels.every(r => r.label.trim() !== "");

        if (anyFilled && !allFilled) {
            ToastStore.showToast("Please fill labels for all rating values or leave all empty.", "warning");
            return;
        }

        // valid → return data to parent
        onSave(ratingLabels);
        onClose();


    };

    return (
        <Dialog
            isOpen={isOpen}
            onClose={onClose}
            title="Rating Definitions"
            portalContainer={document.body}
        >
            <Flexbox flexDirection="column" padding="20px" style={{ maxHeight: "70vh", overflowY: "auto" }}>

                <div className="bp3-text-muted" style={{ fontSize: "14px", marginTop: "3px" }}>
                    Enter labels for rating values ({startRange} – {endRange})
                </div>

                {ratingLabels.map(item => (
                    <Flexbox
                        key={item.value}
                        flexDirection="row"
                        alignItems="center"
                        style={{
                            background: "#f9f9f9",
                            borderRadius: "10px",
                            padding: "15px",
                            marginBottom: "15px"
                        }}
                    >
                        <div
                            style={{
                                width: "40px",
                                height: "40px",
                                borderRadius: "10px",
                                background: "#e8f5e9",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                marginRight: "15px",
                                fontWeight: "bold"
                            }}
                        >
                            {item.value}
                        </div>

                        <FormGroup style={{ flexGrow: 1, marginBottom: 0 }}>
                            <input
                                type="text"
                                className="bp3-input"
                                placeholder={`Label for rating ${item.value}`}
                                value={item.label}
                                onChange={(e) =>
                                    updateLabel(item.value, e.target.value)
                                }
                                style={{
                                    height: "38px",
                                    width: "100%",
                                    border: "1px solid #dedede",
                                    boxShadow: "none"
                                }}
                            />
                        </FormGroup>
                    </Flexbox>
                ))}

                <FilledButton text={"Save Definitions"} type="submit"
                    onClick={() => handleSave()}
                >

                </FilledButton>


            </Flexbox>
        </Dialog>
    );
}));

export default RatingLabelDialog;

